import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Section } from "@/components/common/DetailFields";

const UserRow = ({ u, onSaved }) => {
  const [f, setF] = useState({ name: u.name, username: u.username });
  const [pw, setPw] = useState("");
  const save = async () => {
    try { onSaved((await api.patch(`/admin/users/${u.id}`, f)).data); toast.success("Usuario actualizado"); } catch (e) { toast.error(errMsg(e)); }
  };
  const reset = async () => {
    if (pw.length < 8) return toast.error("Mínimo 8 caracteres");
    try { await api.post(`/admin/users/${u.id}/reset-password`, { new_password: pw }); setPw(""); toast.success(`Contraseña de ${u.name} restablecida; sus sesiones se cerraron.`); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <li data-testid={`user-row-${u.username}`} className="py-3 border-b c-line last:border-0 space-y-2">
      <p className="text-sm font-semibold">{u.name} <span className="text-xs c-muted font-normal">· {u.role === "dueno" ? "Dueño" : "Asistente"}{u.is_me ? " · tú" : ""}</span></p>
      {!u.is_me && (
        <>
          <div className="grid grid-cols-2 gap-2">
            <input data-testid={`user-name-input-${u.username}`} className="c-input" value={f.name} onChange={(e) => setF((s) => ({ ...s, name: e.target.value }))} aria-label="Nombre" />
            <input data-testid={`user-username-input-${u.username}`} className="c-input font-mono" value={f.username} onChange={(e) => setF((s) => ({ ...s, username: e.target.value }))} aria-label="Usuario" />
          </div>
          <button data-testid={`user-save-btn-${u.username}`} onClick={save} className="w-full py-2 rounded-xl c-card text-sm font-semibold">Guardar datos</button>
          <div className="flex gap-2">
            <input data-testid={`user-reset-input-${u.username}`} type="password" autoComplete="new-password" className="c-input flex-1" placeholder="Nueva contraseña" value={pw} onChange={(e) => setPw(e.target.value)} />
            <button data-testid={`user-reset-btn-${u.username}`} onClick={reset} className="px-3 rounded-xl c-card text-sm font-semibold">Restablecer</button>
          </div>
        </>
      )}
    </li>
  );
};

const AddAssistant = ({ onSaved }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", username: "", password: "" });
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: k === "username" ? e.target.value.toLowerCase().trim() : e.target.value }));
  const save = async () => {
    if (f.password.length < 8) return toast.error("La contraseña debe tener al menos 8 caracteres");
    try { onSaved((await api.post("/admin/users", f)).data); setF({ name: "", username: "", password: "" }); setOpen(false); toast.success("Asistente agregado"); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!open) return <button data-testid="add-assistant-btn" onClick={() => setOpen(true)} className="w-full mt-2 py-2.5 rounded-xl c-card text-sm font-semibold">+ Agregar asistente</button>;
  return (
    <div data-testid="add-assistant-form" className="mt-3 space-y-2">
      <input data-testid="assistant-name-input" className="c-input" placeholder="Nombre completo" value={f.name} onChange={set("name")} />
      <input data-testid="assistant-username-input" className="c-input font-mono" placeholder="Usuario" autoCapitalize="none" value={f.username} onChange={set("username")} />
      <input data-testid="assistant-password-input" type="password" autoComplete="new-password" className="c-input" placeholder="Contraseña (mín. 8)" value={f.password} onChange={set("password")} />
      <div className="grid grid-cols-2 gap-2">
        <button onClick={() => setOpen(false)} className="py-2.5 rounded-xl c-card text-sm font-semibold">Cancelar</button>
        <button data-testid="assistant-save-btn" disabled={f.name.trim().length < 2 || f.username.length < 3} onClick={save} className="c-btn-primary py-2.5 text-sm">Crear asistente</button>
      </div>
      <p className="text-[11px] c-muted">El asistente ve CONECTA (sin montos salvo que lo permitas) y nunca Inversiones ni Préstamos.</p>
    </div>
  );
};

export const UsersSection = () => {
  const [users, setUsers] = useState(null);
  useEffect(() => { api.get("/admin/users").then((r) => setUsers(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  return (
    <Section title="Usuarios y roles" testid="config-users">
      {!users ? <p className="text-sm c-muted">Cargando…</p> : <ul>{users.map((u) => <UserRow key={u.id} u={u} onSaved={setUsers} />)}</ul>}
      <AddAssistant onSaved={setUsers} />
    </Section>
  );
};
